export const hideLiveClassActionBtns = (hide) => {
  const liveClassActionBtns = document.getElementById('live-class-action-btns');
  if (!liveClassActionBtns) {
    return;
  }
  if (hide) {
    liveClassActionBtns.classList.add('hideToBottom');
  } else {
    liveClassActionBtns.classList.remove('hideToBottom');
  }
};

export const showBringActionsBack = (show) => {
  const arrowUpActionBtn = document.getElementById('live-class-action-btns-arrow-up');
  if (!arrowUpActionBtn) {
    return;
  }
  if (show) {
    arrowUpActionBtn.classList.add('showFromBottom');
  } else {
    arrowUpActionBtn.classList.remove('showFromBottom');
  }
};
